import ApiLimits from '../ApiLimits';
import DisplayReplyFormArgs from './DisplayReplyFormArgs';
import MessageReadAdapter from '../../adapters/MessageReadAdapter';
import trySanitizeHtml from '../body/trySanitizeHtml';
import { ApiMethodCallback } from '../ApiMethod';
import { createAttachmentFromDisplayFormArgs } from '../attachments/AttachmentsFactory';
import { createErrorResult, createSuccessResult } from '../ApiMethodResponseCreator';
import { getAdapter } from '../../adapters/AdapterManager';

export default async function displayReplyFormApiMethodBase(
    hostItemIndex: string,
    controlId: string,
    data: DisplayReplyFormArgs,
    callback: ApiMethodCallback,
    isReplyAll: boolean
) {
    let htmlBody = '';
    let attachments = [];
    if (data.htmlBody) {
        if (data.htmlBody.length > ApiLimits.MaxBodyLengthOnDisplayApis) {
            callback(createErrorResult());
            return;
        }

        htmlBody = await trySanitizeHtml(data.htmlBody);
        if (htmlBody == null) {
            callback(createErrorResult());
            return;
        }
    }

    if (data.attachments) {
        if (data.attachments.length > ApiLimits.MaxAttachmentNumberOnDisplayApis) {
            callback(createErrorResult());
            return;
        }
        attachments = data.attachments.map(createAttachmentFromDisplayFormArgs);
    }

    const adapter: MessageReadAdapter = getAdapter(hostItemIndex) as MessageReadAdapter;
    await adapter.displayReplyForm(adapter.getItemId(), isReplyAll, htmlBody, attachments);
    callback(createSuccessResult());
}
